// extracted by mini-css-extract-plugin
module.exports = {"footerWrapper":"Footer_footerWrapper__1-_rF","footerShadow":"Footer_footerShadow__waXHQ","codewarsBadges":"Footer_codewarsBadges__q8PUe"};